import ResponsiveNavbar from './responsive-navbar.component';

export default ResponsiveNavbar;



// WEBPACK FOOTER //
// ./index.js